<script>
  import { Icon } from '@shared/ui/icon';
</script>

<section class="bg-default-100 dark:bg-dark-400 dark:text-default-50 flex items-center gap-3 rounded-lg p-4">
  <Icon name="clock-countdown" width="{22}" height="{22}" classes="shrink-0" />

  <p class="text-sm">
    This may take 15 seconds to 5 minutes, depending on network speed and confirmation time. Almost there, thanks for
    waiting!
  </p>
</section>
